import React, {Component} from 'react';
import Radium from 'radium';
import color from 'color';

class MessageListPicture extends Component {

	constructor(props) {
		super(props);

		this.state = {
			scrolled: false,
			hasLoaded: false
		}
	}

	handleHasLoad() {
		this.setState({hasLoaded: true});
		if (!this.state.scrolled) {
			this.setState({scrolled: true});
			setTimeout(() => {
				this.props.scrollToBottom();
			}, 0)
		}
	}

	render() {
		return (
			<div className="message m-type_picture">
				{!this.state.hasLoaded &&
					<div className="message__body m-loading" style={[
							this.props.styles.message.body,
							this.props.styles.message.body.loading,
							this.props.message === this.state.lastElement && this.props.styles.message.body.appear
						]}>
					</div>
				}
				<img 
					src={this.props.message.get("url")} 
					alt="" 
					style={[
						this.props.styles.message.body,
						this.props.message === this.props.lastElement && this.props.styles.message.body.appear,
						this.props.styles.message.body.picture,
						this.state.hasLoaded && this.props.styles.message.body.picture.loaded
					]}
					onLoad={this.handleHasLoad.bind(this)}
					onClick={() => this.props.setLightbox(this.props.message)}
				/>
			</div>
		)
	}
}


export default Radium(MessageListPicture);


// WEBPACK FOOTER //
// ./src/components/MessageList/MessageListPicture.js